export default {
  // This makes your getters, mutations, and actions accessed by, eg: 'myModule/myModularizedNumber' instead of mounting getters, mutations, and actions to the root namespace.
  namespaced: false,


  state: {
    login: true,

    responsive: {
      navItems: [],
      floatingButtons: [],
      navItemLeft: [],
      navItemRight: [],
      createActivity: true
    },

    


    navButtons: {
      mobile: {
        title: 'Mobile', 
        icon: 'fas fa-mobile-alt'
      },
      placeholder: {
        title: '', 
        icon: '',
        path: '',
        color: 'white', 
        disabled: true 
      },
      filter: {
        title: 'Filter',
        icon: 'fas fa-sliders-h',
        method: 'clicktimelinedrawer',
        payload: true,
        class: 'openFilter',
      },
      notifications: {
        title: 'Notifications', 
        icon: 'fas fa-bell',
        path: '/notifications',
        color: 'blue-grey lighten-1',

        notifications: true 
      },
      
      search: {
        title: 'Search',
        icon: 'fas fa-search',
        method: 'activateSearch',
        payload: true,
        class: 'openFilter',
      },
      close: {
        title: 'Close',
        icon: 'fas fa-times',
        method: 'activateSearch',
        payload: true,
        class: 'openFilter',
      },
      settings: { 
        title: 'Settings', 
        icon: 'fas fa-cog',
        class: 'openFilter',
        method: 'click_profile_settingsdrawer',
        payload: true,
      },
      timeline: {
        title: 'Timeline',
        path: '/timeline',
        icon: 'fas fa-home',
        color: 'blue-grey lighten-1',
        disabled: false
      },
      
      favorites: {
        title: 'Favorites',
        path: '/favorites',
        icon: 'fas fa-heart',
        color: 'blue-grey lighten-1',
        disabled: false
      },
      
      friends: {
        title: 'Friends',
        path: '/friends',
        icon: 'fas fa-user-friends',
        color: 'blue-grey lighten-1',
        disabled: false
      },
      
      profile: {
        title: 'Profile',
        path: '/profile',
        icon: 'fas fa-user',
        color: 'blue-grey lighten-1',
        disabled: false
      },
      signin: { 
        value: 'Sign In', 
        path: '/', 
        icon: 'fas fa-sign-in-alt', 
        color: 'blue-grey lighten-1',
        disabled: false 
      },
      // logout: {
      //   value: 'Log Out',  
      //   icon: 'fas fa-logout', 
      //   color: 'teal',
      //   method: 'logout',
      //   class: 'openFilter',
      //   payload: null,
      //   disabled: false 
      // },
      add: {
        title: 'Add',
        to: '/add',
        method: 'click',
        payload: null,
        class: 'addEvent',
        icon: 'fas fa-plus'
      },
      
    },
  
  },


  getters: {
    
  },


  mutations: {
    setLogin: (state, payload) => {
      state.login = payload
    },

    setCreateActivity: (state, payload) => {
      console.log(payload)
      state.responsive.createActivity = payload
    },

    setNavElementSearch: (state, payload) => {
      if (payload) {
        state.responsive.navItemLeft = [
          state.navButtons.close
        ] 
        state.responsive.floatingButtons = [
          state.navButtons.close
        ]
      } else {
        state.responsive.navItemLeft = [
          state.navButtons.search
        ] 
        state.responsive.floatingButtons = [
          state.navButtons.search
        ]
      }
        
    },

    navElementsMobile: (state, payload) => {
      if (payload.user !== null && payload.user !== undefined) {
        console.log('navnav', (payload.path.match(/timel/) || {}).input)
        switch (payload.path) {
      
        
        case (payload.path.match(/timeline/) || {}).input:
          state.responsive.navItemLeft = [
            state.navButtons.filter
          ]
          state.responsive.navItemRight = [
            state.navButtons.notifications
          ]
          break
        case (payload.path.match(/friends/) || {}).input:
          state.responsive.navItemLeft = [
            state.navButtons.search           
          ]
          state.responsive.navItemRight = [
            state.navButtons.notifications
          ]
          break
        case (payload.path.match(/favorites/) || {}).input:
          state.responsive.navItemLeft = [
            state.navButtons.placeholder
            // TODO
            // state.navButtons.filter
          ]
          state.responsive.navItemRight = [
            state.navButtons.notifications
          ]
          break
        case (payload.path.match(/profile\//) || {}).input:
          state.responsive.navItemLeft = [
            state.navButtons.placeholder
          ]
          state.responsive.navItemRight = [
            state.navButtons.notifications
          ]
          break
        case (payload.path.match(/profile/) || {}).input:
          state.responsive.navItemLeft = [
            state.navButtons.settings
          ]
          state.responsive.navItemRight = [
            state.navButtons.notifications
          ]
          break
        // case '/profile/user':
        //   state.responsive.navItemLeft = [
        //     state.navButtons.search
        //   ]
        //   state.responsive.navItemRight = [
        //     state.navButtons.notifications
        //   ]
        //   break
        case (payload.path.match(/notifications/) || {}).input:
          state.responsive.navItemLeft = [
            state.navButtons.placeholder
          ]
          state.responsive.navItemRight = [
            state.navButtons.notifications
          ]
          break
        // case (payload.path.match(/\//) || {}).input:
        //   state.responsive.navItemRight = [
        //     state.navButtons.mobile
        //   ]
        //   state.responsive.navItemLeft = [
        //     state.navButtons.placeholder
        //   ]
        //   break
        default:
          state.responsive.navItemLeft = []
          state.responsive.navItemRight = []
        }
  
        state.responsive.navItems = [
          state.navButtons.timeline,
          state.navButtons.favorites,
          state.navButtons.placeholder,
          state.navButtons.friends,
          // state.navButtons.profile,
        ] 
  
      } else {
        state.responsive.navItems = [
          state.navButtons.signin
        ]
      }
    },
  
  
    navElementsDesktop: (state, payload) => {
      if (payload.user !== null && payload.user !== undefined) {
        switch (payload.path) {
        case '/':
          state.responsive.floatingButtons = []
          break
        case '/timeline':
          state.responsive.floatingButtons = [
            state.navButtons.add,
            state.navButtons.filter
          ]
          break
        case '/friends':
          state.responsive.floatingButtons = [
            state.navButtons.search
          ]
          break
        case '/favorites':
          state.responsive.floatingButtons = []
          // state.navButtons.filter
          // ]
          break
        case '/profile':
          state.responsive.floatingButtons = [
            state.navButtons.settings
          ]
          break
        default:
          state.responsive.floatingButtons = []
        }
      
  
        state.responsive.navItems = [
          state.navButtons.timeline,
          state.navButtons.favorites,
          state.navButtons.friends,
          state.navButtons.notifications,
        ]
      } else {
        state.responsive.floatingButtons = []
        state.responsive.navItems = [
          state.navButtons.signin
        ]
      }
    },
  },

  actions: {
    
  }
}